// ヘッダー文字色：ヘッダーの真下にある背景の明るさを測り、白(#F1F1F2)か黒(#333)を選ぶ（07-home）。
// 画像ブロック（data-sample）は描画どおりに canvas へ縮小コピーして画素を平均する。それ以外はページ色 #DEDEDE。
// Home 以外は body.hdr-dark で CSS が黒に固定するので何もしない。
(function () {
  if (document.body.classList.contains('hdr-dark')) return;
  var hdr = document.getElementById('hdr');
  if (!hdr) return;
  var H = 54, SCALE = 4;
  var blocks = [].slice.call(document.querySelectorAll('[data-sample]')).map(function (el) {
    return { el: el, img: el.querySelector(':scope > img'), canvas: null, tainted: false };
  });

  function build(b) {
    var img = b.img;
    if (!img || !img.naturalWidth) return null;
    var r = b.el.getBoundingClientRect();
    var W = Math.round(r.width), Hh = Math.round(r.height);
    var s = Math.max(W / img.naturalWidth, Hh / img.naturalHeight);
    var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    var pos = (getComputedStyle(img).objectPosition || '50% 50%').split(' ').map(function (v) { return parseFloat(v) / 100; });
    var ox = (W - dw) * (isNaN(pos[0]) ? 0.5 : pos[0]), oy = (Hh - dh) * (isNaN(pos[1]) ? 0.5 : pos[1]);
    var c = document.createElement('canvas');
    c.width = Math.ceil(W / SCALE);
    c.height = Math.ceil(Hh / SCALE);
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, ox / SCALE, oy / SCALE, dw / SCALE, dh / SCALE);
    // crossorigin="anonymous" が無い CDN 画像は canvas が汚染されて読めない。その場合は「暗い」扱いにして白文字を出す
    try { ctx.getImageData(0, 0, 1, 1); } catch (e) { b.tainted = true; return null; }
    b.canvas = c;
    return c;
  }

  var deferBuild = true;

  // ブロック内座標で x0..x1 × y0..y0+H の平均輝度 (0..1)
  function lum(b, x0, x1, y0) {
    var c = b.canvas || (deferBuild ? null : build(b));
    if (!c) return b.tainted ? 0.3 : 0.87; // 画像が無い＝ページ色 #DEDEDE と同じ扱い
    var sx = Math.max(0, Math.floor(x0 / SCALE)), sw = Math.max(1, Math.floor((x1 - x0) / SCALE));
    var sy = Math.max(0, Math.floor(y0 / SCALE)), sh = Math.max(1, Math.min(c.height - sy, Math.floor(H / SCALE)));
    var d;
    try { d = c.getContext('2d', { willReadFrequently: true }).getImageData(sx, sy, sw, sh).data; } catch (e) { return 0.3; }
    var t = 0, n = 0;
    for (var i = 0; i < d.length; i += 4) { t += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }
    return n ? t / n / 255 : 0.5;
  }

  function under(y) {
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      var r = b.el.getBoundingClientRect();
      var top = r.top + scrollY;
      if (y >= top && y < top + r.height) return { b: b, rel: y - top };
    }
    return null;
  }

  function update() {
    var y = scrollY;
    var hit = under(y + H / 2);
    var lLogo = 0.87, lNav = 0.87; // 画像がない場所は #DEDEDE (輝度 0.87)
    if (hit) {
      lLogo = lum(hit.b, 27, 147, hit.rel - H / 2);
      lNav = lum(hit.b, innerWidth - 260, innerWidth - 27, hit.rel - H / 2);
    }
    // hero の大きな白ロゴがヘッダーの下を通る間は、その範囲を明るい背景として扱う
    var big = document.querySelector('.hero-logo');
    if (big) {
      var r = big.getBoundingClientRect();
      if (r.bottom > 0 && r.top < H) {
        if (r.right > 27 && r.left < 147) lLogo = Math.max(lLogo, 0.9);
        if (r.right > innerWidth - 260 && r.left < innerWidth - 27) lNav = Math.max(lNav, 0.9);
      }
    }
    hdr.classList.toggle('logo-dark', lLogo > 0.5);
    hdr.classList.toggle('nav-dark', lNav > 0.5);
  }

  var ticking = false;
  addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
  }, { passive: true });
  addEventListener('resize', function () {
    blocks.forEach(function (b) { b.canvas = null; });
    update();
  });
  // 画像を canvas に写して画素を読むのは重いので、読み込みが終わったあとの空き時間に回す（19-seo C1）。
  // それまでは画像なし＝ページ色の扱いで黒文字になり、今の Hero の上端（明るい）と同じ結果になる
  function idleUpdate() {
    (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(function () {
      deferBuild = false;
      update();
    }, { timeout: 1000 });
  }
  if (document.readyState === 'complete') idleUpdate();
  else addEventListener('load', idleUpdate, { once: true });
  update();
})();
